import { useCallback, useState } from "react";
import { useSelector } from "react-redux";

/**
 * Per-user browser persistence for the lists the wireframes keep in localStorage
 * (sent truck requests). The backend has no
 * endpoint for them, so — exactly like the wireframe — they live in the browser,
 * but scoped by the signed-in user id.
 */
const read = (k, d) => {
  try {
    const v = JSON.parse(window.localStorage.getItem(k));
    return v ?? d;
  } catch {
    return d;
  }
};
const write = (k, v) => {
  try {
    window.localStorage.setItem(k, JSON.stringify(v));
  } catch {
    /* storage unavailable */
  }
};

export const useUid = () => useSelector((s) => s.auth?.user?.id) ?? "anon";

/** A list persisted under `itruck.cab.<name>:<uid>`. */
export function useStoredList(name) {
  const uid = useUid();
  const key = `itruck.cab.${name}:${uid}`;
  const [list, setList] = useState(() => read(key, []));
  const update = useCallback(
    (fn) =>
      setList((cur) => {
        const next = fn(cur);
        write(key, next);
        return next;
      }),
    [key],
  );
  return [list, update];
}

/** Sent truck requests: [{vehicle_id, order, at}] — drives «Заявка отправлена». */
export function useSentRequests() {
  const [list, update] = useStoredList("sent.trucks");
  const has = (vehicleId) => list.some((x) => x.vehicle_id === Number(vehicleId));
  const add = (vehicleIds, order) =>
    update((cur) => [
      ...cur.filter((x) => !vehicleIds.includes(x.vehicle_id)),
      ...vehicleIds.map((v) => ({ vehicle_id: Number(v), order, at: Date.now() })),
    ]);
  return { has, add };
}
